// extracted by mini-css-extract-plugin
export default {"wrapper":"Nw-z","addressLine":"Ow-z","fullName":"Pw-z"};